const browserInfo = require('../../js/single_webrtc').getBrowserInfo()

angular
  .module('surfsightApp.controllers')
  .controller('edgeListControllerDeprecated', [
    '$scope',
    '$rootScope',
    '$state',
    '$stateParams',
    '$timeout',
    '$interval',
    '$location',
    '$window',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    '$mdMedia',
    'edgeFactory',
    'edgeGroupFactory',
    'broadcastViewFactory',
    'leafletData',
    'leafletBoundsHelpers',
    'nominatimLookUp',
    function (
      $scope,
      $rootScope,
      $state,
      $stateParams,
      $timeout,
      $interval,
      $location,
      $window,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdSidenav,
      $mdToast,
      $mdColors,
      $mdMedia,
      edgeFactory,
      edgeGroupFactory,
      broadcastViewFactory,
      leafletData,
      leafletBoundsHelpers,
      nominatimLookUp
    ) {
      const $translate = $filter('translate')
      let searchTextTimer
      $scope.trackSearchText = () => {
        searchTextTimer && $timeout.cancel(searchTextTimer)
        searchTextTimer = $timeout(() => {
          $scope.deviceSearchState.highlightText =
            $scope.deviceSearchState.searchText
          requestGroupPagination(true) // load devices with default pagination
        }, 1500)
      }
      $scope.deviceSearchState = {
        searchText: '',
        highlightText: '',
        groupPaginations: {}
      }
      const clearGroupDevices = groupId => {
        const previousDevices = edgeFactory.list.filter(
          device => device.groupId === groupId
        )
        previousDevices.forEach(device => {
          edgeFactory.deleteItemById(device.id)
        })
      }
      const requestGroupPagination = (
        allGroups = true,
        groupId = false,
        page = 1,
        limit = 200
      ) => {
        const { searchText } = $scope.deviceSearchState
        if (allGroups) {
          edgeGroupFactory.list.forEach(edgeGroup => {
            clearGroupDevices(edgeGroup.id)
            edgeGroup.opened = !!searchText || edgeGroup.id === -1
          })
        }
        const requestEdgeGroups = edgeGroupFactory.list.filter(
          edgeGroup =>
            (allGroups && (searchText || edgeGroup.id === -1)) ||
            edgeGroup.id === groupId
        )
        const groupPaginations = requestEdgeGroups.map(edgeGroup => ({
          groupId: edgeGroup.id,
          limit,
          page
        }))
        requestEdgeGroups.forEach(edgeGroup => {
          edgeGroup.opened = edgeGroup.opened || allGroups
          $scope.deviceSearchState.groupPaginations[edgeGroup.id] = {
            loading: true,
            page,
            dashcams: [],
            totalCount: 0
          }
        })
        const deviceSearchRequest = {
          searchText,
          groupPaginations
        }
        const requestJson = {
          method: 'POST',
          url: `${EDGE_BASEURL}/organizationEdges/${$rootScope.currentUserOrganization.id}/list`,
          data: deviceSearchRequest
        }
        $http(requestJson)
          .then(response => {
            if (response.data.status.code === 0) {
              const { groupPaginationResponses } = response.data
              groupPaginationResponses.forEach(groupPaginationResponse => {
                const {
                  groupId,
                  dashcams,
                  totalCount
                } = groupPaginationResponse
                const lastPage = Math.ceil(totalCount / limit)
                const startOfRecords = page === 1 ? 1 : (page - 1) * limit + 1
                const endOfRecords =
                  page === lastPage ? totalCount : page * limit
                $scope.deviceSearchState.groupPaginations[groupId] = {
                  loading: false,
                  page,
                  limit,
                  dashcams,
                  totalCount,
                  startOfRecords,
                  endOfRecords,
                  lastPage
                }
                clearGroupDevices(groupId)
                dashcams.forEach(device => {
                  edgeFactory.addOrUpdateItem(device)
                })
                const serialNumbers = dashcams.map(device => device.uri)
                if (allGroups && totalCount === 0) {
                  const edgeGroup = edgeGroupFactory.list.find(
                    e => e.id === groupId
                  )
                  edgeGroup.opened = false
                }
                $scope.$emit('devicesOnlineStatusRequest', {
                  serialNumbers,
                  includeLastLocation: false
                })
              })
              $scope.$emit('loadEdgesEvt', {})
            }
          })
          .catch(error => {
            console.error('requestGroupPagination', error)
            handleServerError(error)
            groupPaginations.forEach(({ groupId }) => {
              $scope.deviceSearchState.groupPaginations[groupId] = {
                loading: false,
                page,
                limit,
                dashcams: [],
                totalCount: 0,
                startOfRecords: 0,
                endOfRecords: 0,
                lastPage: 0
              }
            })
          })
      }
      requestGroupPagination()
      $scope.groupNavigation = (groupId, pageIndicator) => {
        const groupPagination =
          $scope.deviceSearchState.groupPaginations[groupId]
        if (!groupPagination) {
          return
        }
        const { page, limit, totalCount } = groupPagination
        const lastPage = Math.ceil(totalCount / limit)
        let newPage
        switch (pageIndicator) {
          case 'first':
            newPage = 1
            break
          case 'previous':
            newPage = page === 1 ? 1 : page - 1
            break
          case 'next':
            newPage = page === lastPage ? lastPage : page + 1
            break
          case 'last':
            newPage = lastPage
            break
          case 'current':
            newPage = page
            break
          default:
            newPage = 1
            break
        }
        if (newPage === page && pageIndicator !== 'current') {
          return
        }
        $scope.deviceSearchState.groupPaginations[groupId] = {
          ...groupPagination,
          page: newPage
        }
        requestGroupPagination(false, groupId, newPage, limit)
      }
      $scope.edge_list_loading = false

      edgeFactory.list.forEach(function (e, i) {
        e.opened = false
        edgeFactory.addOrUpdateItem(e)
      })
      $scope.deviceListScrollbarOptions = {
        enable: $mdMedia('gt-sm'),
        autoHide: false
      }
      $scope.currentState = $state.current.name
      if ($scope.currentState === 'home.common.edge.list') {
        $timeout(function () {
          $scope.openSideNav('edge-list')
          if ($mdMedia('gt-sm')) {
            $scope.openSideNav('multiple-braodcast-videos')
          }
        })
      } else if ($scope.currentState === 'home.common.maps.view') {
        $timeout(function () {
          $scope.openSideNav('edge-list')
          if ($mdMedia('gt-sm')) {
            $scope.openSideNav('edges-map-sidenav')
          }
        }, 100)
      }
      $scope.bulkDevicesSelectionsState = {
        canShow: ['home.common.edge.list', 'home.common.events'].includes(
          $state.$current.name
        ),
        actions: {
          eventSettings: {
            show: $state.$current.name === 'home.common.events'
          },
          uiSettings: {
            show: $state.$current.name === 'home.common.edge.list'
          }
        },
        show: false,
        bulkDevicesSelections: {
          groupIds: [],
          intermediateGroupIds: [],
          groups: [],
          serialNumbers: [],
          allExcludedSerialNumbers: [],
          devices: []
        }
      }
      const getBulkDeviceSelections = () => {
        const {
          groups,
          serialNumbers
        } = $scope.bulkDevicesSelectionsState.bulkDevicesSelections
        return {
          groups,
          serialNumbers
        }
      }
      $scope.toggleGroupSelection = group => {
        const { id: groupId } = group
        const index = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups.findIndex(
          g => g.groupId === groupId
        )
        if (index > -1) {
          $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups.splice(
            index,
            1
          )
        } else {
          $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups.push({
            groupId,
            ...(groupId === -1 && {
              organizationId: $localStorage.currentUserOrganization.id
            }),
            excludeSerialNumbers: []
          })
        }
        $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices.filter(
          d => d.groupId !== groupId
        )
        refreshSelectionData()
      }
      $scope.toggleDeviceSelection = device => {
        const { uri: serialNumber, groupId } = device
        const index = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices.findIndex(
          d => d.uri === serialNumber
        )
        if (index > -1) {
          $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices.splice(
            index,
            1
          )
        } else {
          const groupSelection = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups.find(
            g => g.groupId === groupId
          )
          if (groupSelection) {
            const excludedSerialNumberIndex = groupSelection.excludeSerialNumbers.indexOf(
              serialNumber
            )
            if (excludedSerialNumberIndex > -1) {
              groupSelection.excludeSerialNumbers.splice(
                excludedSerialNumberIndex,
                1
              )
            } else {
              groupSelection.excludeSerialNumbers.push(serialNumber)
            }
          } else {
            $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices.push(
              device
            )
          }
        }
        refreshSelectionData()
      }
      const refreshSelectionData = () => {
        const serialNumbers = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices.map(
          ({ uri }) => uri
        )
        const groupIds = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups.map(
          ({ groupId }) => groupId
        )
        const intermediateGroupIds = [
          ...$scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups
            .filter(({ excludeSerialNumbers }) => excludeSerialNumbers.length)
            .map(({ groupId }) => groupId),
          ...$scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices.map(
            ({ groupId }) => groupId
          )
        ]

        $scope.bulkDevicesSelectionsState.bulkDevicesSelections.serialNumbers = serialNumbers
        $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groupIds = groupIds
        $scope.bulkDevicesSelectionsState.bulkDevicesSelections.intermediateGroupIds = intermediateGroupIds
        $scope.bulkDevicesSelectionsState.bulkDevicesSelections.allExcludedSerialNumbers = $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups.reduce(
          (_allExcludedSerialNumbers, { excludeSerialNumbers }) => [
            ..._allExcludedSerialNumbers,
            ...excludeSerialNumbers
          ],
          []
        )
        $scope.bulkDevicesSelectionsState.show =
          serialNumbers.length + groupIds.length !== 0
      }
      const clearSelectionData = () => {
        $scope.bulkDevicesSelectionsState.bulkDevicesSelections.groups = []
        $scope.bulkDevicesSelectionsState.bulkDevicesSelections.devices = []
        refreshSelectionData()
      }
      $scope.$on('currentSideNavAddBtnReceive', function (e, data) {
        $scope.showEdgeModal(data)
      })
      const statusTimer = $interval(function () {
        const serialNumbers = edgeFactory.list.map(device => device.uri)
        $scope.$emit('devicesOnlineStatusRequest', {
          serialNumbers,
          includeLastLocation: false
        })
      }, 15000)
      $scope.$watch(
        () => {
          return edgeFactory.list
        },
        (current, previous) => {
          $scope.edge_list = current
        }
      )
      $scope.$on(
        'devicesOnlineStatusResponse',
        (_, devicesOnlineStatusResponse) => {
          const serialNumberDeviceOnlineStatusResponseMap = devicesOnlineStatusResponse.reduce(
            (
              _serialNumberDeviceOnlineStatusResponseMap,
              deviceOnlineStatusResponse
            ) => ({
              ..._serialNumberDeviceOnlineStatusResponseMap,
              [deviceOnlineStatusResponse.serialNumber]: deviceOnlineStatusResponse
            }),
            {}
          )
          Object.keys($scope.deviceSearchState.groupPaginations).forEach(
            groupKey => {
              $scope.deviceSearchState.groupPaginations[
                groupKey
              ].dashcams.forEach((device, deviceIndex) => {
                const serialNumber = device.uri
                const deviceOnlineStatusResponse =
                  serialNumberDeviceOnlineStatusResponseMap[serialNumber]
                if (!deviceOnlineStatusResponse) return
                const edge = edgeFactory.list.find(e => e.uri === serialNumber)
                if (!edge) return
                const onlineStatus =
                  deviceOnlineStatusResponse.status === 'online'
                edge.proxy_connected = onlineStatus
                $scope.deviceSearchState.groupPaginations[groupKey].dashcams[
                  deviceIndex
                ].proxy_connected = onlineStatus
                edge.standby = deviceOnlineStatusResponse.standby
                $scope.deviceSearchState.groupPaginations[groupKey].dashcams[
                  deviceIndex
                ].standby = deviceOnlineStatusResponse.standby
                if (deviceOnlineStatusResponse.isSemiOnline !== undefined) {
                  edge.isSemiOnline = deviceOnlineStatusResponse.isSemiOnline
                  $scope.deviceSearchState.groupPaginations[groupKey].dashcams[
                    deviceIndex
                  ].isSemiOnline = deviceOnlineStatusResponse.isSemiOnline
                }
              })
            }
          )
        }
      )
      $scope.$on(
        'deviceCamerasStatusResponse',
        (_, { serialNumber, cameraIds }) => {
          const edge = edgeFactory.list.find(
            device => device.uri === serialNumber
          )
          if (edge) edge.onlineCameraIds = cameraIds
        }
      )
      $scope.sortBy = function (sort, order) {
        $scope.sortByName = sort || 'creationTime'
        $scope.orderBy = order || 'desc'
        $rootScope.selectedSortOptionAnalytics =
          order === '' ? 'creationTime' : order
        loadEdgeGroups(true)
      }
      $scope.edge_groups = edgeGroupFactory.list
      const loadEdgeGroups = (reset = false) => {
        if (!reset) {
          if (edgeGroupFactory.list.length !== 0) {
            $scope.edge_groups = edgeGroupFactory.list
            return
          }
        } else {
          edgeGroupFactory.list.push({ id: -1, name: 'devices', opened: true })
        }
        $scope.edge_groups_loading = true
        const requestJson = {
          method: 'GET',
          url:
            EDGE_BASEURL +
            '/organizationEdge_groups/' +
            $rootScope.currentUserOrganization.id +
            `?sort=${$scope.sortByName ||
              'creationTime'}&order=${$scope.orderBy || 'desc'}`
        }
        $http(requestJson).then(
          function (response) {
            if (response.data.status.code == 0) {
              edgeGroupFactory.list = response.data.edgeGroups.map(e => {
                e.edges = []
                return e
              })
              $scope.edge_groups = edgeGroupFactory.list
              $scope.edge_groups.push({
                id: -1,
                name: 'devices',
                opened: true,
                edges: []
              })
            } else {
              edgeGroupFactory.list = []
              $scope.edge_groups = edgeGroupFactory.list
              edgeGroupFactory.list.push({
                id: -1,
                name: 'devices',
                opened: true
              })
            }
            $scope.edge_groups_loading = false
            requestGroupPagination(false, -1)
            $rootScope.edgeGroupsLoaded = true
          },
          function (response) {
            handleServerError(response)
            if (response.data.status) {
              showMessageToast(response.data.status.error)
            }
          }
        )
      }
      ;(!$rootScope.edgeGroupsLoaded || edgeGroupFactory.list.length === 0) &&
        loadEdgeGroups(true)
      const redirectToGroupReports = groupId => {
        $state.go('home.common.reports.edgegroup', {
          edge_group_id: groupId
        })
      }
      $scope.collapseEdgeGroup = (
        group,
        selected_sideStripe_menu,
        expandOnly = false
      ) => {
        if (selected_sideStripe_menu === 5 && !expandOnly) {
          redirectToGroupReports(group.id)
        } else {
          group.opened = !group.opened
          edgeGroupFactory.addOrUpdateItem(group)
          if (group.opened) {
            requestGroupPagination(false, group.id, 1)
          } else {
            // clear collapsed edge group devices
            const previousDevices = edgeFactory.list.filter(
              device => device.groupId === group.id
            )
            previousDevices.forEach(device => {
              edgeFactory.deleteItemById(device.id)
            })
            $scope.$emit('loadEdgesEvt', {})
          }
        }
      }
      $scope.showEdgeModal = ev => {
        $mdDialog
          .show({
            locals: {
              dataFromCaller: {
                whitelabel: $rootScope.data.whitelabel
              }
            },
            controller: 'EdgeModalController',
            templateUrl:
              './templates/edge.modal.view.html?t=' + window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(response => {
            if (response.data.type === 'edge') {
              const groupId = -1 // default group for unassigned edges
              $scope.groupNavigation(groupId, 'current')
            } else {
              loadGroupDetails(response.data.id)
            }
          })
      }
      $scope.confirmEdgeDelete = (ev, deviceId) => {
        // Appending dialog to document.body to cover sidenav in docs app
        const confirm = $mdDialog
          .confirm()
          .title($translate('areYouSureYouWantToDeleteThisEdge'))
          .textContent('')
          .ariaLabel($translate('deleteEdge'))
          .targetEvent(ev)
          .ok($translate('delete'))
          .cancel($translate('cancel'))

        $mdDialog.show(confirm).then(
          () => {
            const requestJson = {
              method: 'DELETE',
              url: EDGE_BASEURL + '/edge/' + deviceId,
              data: $scope.edgeData
            }
            $http(requestJson).then(
              response => {
                if (response.data.status.code === 0) {
                  showMessageToast(response.data.status.error)
                }
                loadEdgeGroups(true)
                leafletData.getMap().then(function (map) {
                  map.closePopup()
                })
              },
              response => {
                handleServerError(response)
                showMessageToast(response.data.status.error)
              }
            )
          },
          () => {
            // discard delete.
          }
        )
      }
      $scope.confirmUpdateUiSettings = (
        ev,
        edge,
        data,
        isBulkDeviceSelection = false
      ) => {
        const confirm = $mdDialog
          .confirm()
          .title($translate('cameraSettingWillBeOverwritten'))
          .textContent('')
          .ariaLabel($translate('settings'))
          .targetEvent(ev)
          .ok($translate('ok'))
          .cancel($translate('cancel'))

        $mdDialog.show(confirm).then(
          () => {
            const message = {
              message_type: 'uiConfig',
              data
            }
            const requestData = isBulkDeviceSelection
              ? {
                  bulkDevicesSelections: getBulkDeviceSelections(),
                  message
                }
              : message
            const requestJson = {
              method: 'POST',
              url: isBulkDeviceSelection
                ? `${DEVICEMANAGER_BASEURL}/v1.1/devices/bulk-message-per-selection`
                : `${DEVICEMANAGER_BASEURL}/device/${edge.uri}/messages`,
              data: requestData
            }
            $http(requestJson)
              .then(result => {
                if (result.data.status.code === 0) {
                  showMessageToast($translate('deviceSettingsUpdated'))
                } else {
                  handleServerError(result)
                  showMessageToast(result.data.status.error)
                }
              })
              .catch(ex => {
                $scope.showMessageToast(ex)
              })
            clearSelectionData()
          },
          () => {
            // return to edge edit dialog
            if (!isBulkDeviceSelection) {
              $scope.showEditEdge(ev, edge)
            }
            clearSelectionData()
          }
        )
      }
      $scope.showEditEdge = (ev, edge) => {
        const deviceId = edge.id // edge_id
        $mdDialog
          .show({
            locals: {
              dataFromCaller: {
                edge_id: deviceId,
                edge: angular.copy(edge),
                whitelabel: $rootScope.data.whitelabel
              }
            },
            controller: 'EdgeEditController',
            templateUrl:
              './templates/edge.edit.view.html?t=' + window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(
            response => {
              if (response.type === 'delete') {
                $scope.confirmEdgeDelete(ev, deviceId)
                return
              }
              if (response.type === 'settings_changed') {
                $scope.confirmUpdateUiSettings(ev, response.edge, response.data)
                return
              }
              if (['rma', 'settings_unchanged'].includes(response.type)) {
                if (response.message) {
                  showMessageToast(response.message)
                }
                return
              }
              showMessageToast(response.data.status.error)
              if (response.data.status.code === 0) {
                const { groupId } = edge
                $scope.groupNavigation(groupId, 'current')
              }
            },
            response => {
              if (
                response &&
                response.data &&
                response.data.requestResponse &&
                response.data.requestResponse.status
              ) {
                showMessageToast($translate('upgradeIsSentToDevice'))
              }
            }
          )
      }
      setTimeout(function () {
        fireRefreshEventOnWindow()
      }, 500)
      const showMessageToast = message => {
        const toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .actionKey('F1')
          .position('top right')
          .hideDelay(5000)

        $mdToast
          .show(toast)
          .then(function (response) {
            if (response == 'ok') {
              // alert('You clicked the \'UNDO\' action.');
            }
          })
          .catch(() => {})
      }
      $scope.edgesMoved = async (group, edge, ev) => {
        const sourceGroupId = edge.groupId
        const destinationGroupId = group.id
        if (sourceGroupId === destinationGroupId) {
          return
        }
        const requestJson = {
          method: 'PUT',
          url: `${EDGE_BASEURL}/device/${edge.uri}/group/${destinationGroupId}`,
          data: {}
        }
        try {
          await $http(requestJson)
          $scope.groupNavigation(sourceGroupId, 'current')
          $scope.groupNavigation(destinationGroupId, 'current')
        } catch (error) {
          handleServerError(error)
        }
      }
      $scope.showEdgeOptions = (edge, edge_type, $event) => {
        $scope.showEditEdge($event, edge)
      }
      $scope.isEdgeBroadcastVideos = false
      $scope.broadcastViews = broadcastViewFactory.list
      $scope.getBroadcastViewById = id =>
        $filter('filter')(broadcastViewFactory.list, { id: id })[0]
      const loadBroadcastViews = async () => {
        const requestJson = {
          method: 'GET',
          url: `${BROADCAST_BASEURL}/organizationUserBroadcastViews/${$rootScope.currentUserOrganization.id}`
        }
        try {
          const response = await $http(requestJson)
          if (response.data.status.code == 0) {
            $scope.defaultView = false
            response.data.broadcastViews.forEach(function (broadcastView) {
              if (broadcastView.type === 1) {
                // $scope.openSideNav('multiple-braodcast-videos');
                $scope.defaultView = broadcastView
                $scope.showBroadcastView(broadcastView)
              }
              broadcastViewFactory.addOrUpdateItem(broadcastView)
            })
          }
        } catch (error) {
          handleServerError(error)
        }
      }
      $scope.deleteBroadcastView = (ev, broadcastViewID) => {
        const confirm = $mdDialog
          .confirm(ev)
          .title($translate('areYouSureYouWantToDeleteThisBroadcastView'))
          .textContent('')
          .ariaLabel($translate('deleteBroadcastView'))
          .targetEvent(ev)
          .ok($translate('delete'))
          .cancel($translate('cancel'))
        $mdDialog.show(confirm).then(
          async () => {
            const requestJson = {
              method: 'DELETE',
              url: BROADCAST_BASEURL + '/broadcastView/' + broadcastViewID
            }
            try {
              const response = await $http(requestJson)
              showMessageToast(response.data.status.error)
              if (response.data.status.code === 0) {
                broadcastViewFactory.deleteItemById(broadcastViewID)
              }
            } catch (error) {
              handleServerError(error)
            }
          },
          function () {
            // Cancel
          }
        )
      }
      $scope.broadcastViewId = ''
      $scope.showBroadcastView = broadcastView => {
        $scope.broadcastViewId = broadcastView.id
        $scope.isEdgeBroadcastVideos = false
        $scope.isNewBroadcastView = false
        var broadcastViewData = broadcastView.broadcastViewData
        $scope.$emit('broadcastViewRequest', {
          broadcastViewData: broadcastViewData,
          broadcastViewId: $scope.broadcastViewId
        })
        $scope.showMultipleBroadcastVideos(broadcastView.id)
      }
      $scope.isNewBroadcastView = true
      $scope.showMapMultipleBroadcasts = (
        broadcast,
        changeMapCenter = false
      ) => {
        $scope.openSideNav('map-multiple-braodcast-videos')
        $scope.$emit('changeMapCenterEvent', {
          broadcast: broadcast,
          changeMapCenter: changeMapCenter
        })
      }
      $scope.broadcastsAdded = (edgeId, streamId, open_sidepanel = false) => {
        const edge = edgeFactory.findItemById(edgeId).item
        const dashcamStream = {
          serialNumber: edge.serialNumber || edge.uri,
          streamId,
          cameraName: edge.name
        }
        $scope.$emit('dashcamStreamsAddedRequest', {
          dashcamStreams: [dashcamStream]
        })
      }
      $scope.$on('closeBroadcastViewRecieve', (e, data) => {
        if ($scope.currentState === 'home.common.maps.view') {
          $mdSidenav('map-multiple-braodcast-videos').close()
          if ($mdMedia('xs') || $mdMedia('sm')) {
            $mdSidenav('edge-list').open()
          }
        } else if ($scope.currentState === 'home.common.edge.list') {
          if ($mdMedia('xs') || $mdMedia('sm')) {
            $mdSidenav('multiple-braodcast-videos').close()
            $mdSidenav('edge-list').open()
          }
        }
      })
      $scope.showMultipleBroadcastVideos = (broadcastViewId = false) => {
        $scope.broadcastViewId = broadcastViewId
      }
      $scope.showEditEdgeGroup = (ev, groupId) => {
        $mdDialog
          .show({
            locals: {
              dataFromCaller: {
                edge_group_id: groupId
              }
            },
            controller: 'EditEdgeGroupController',
            templateUrl:
              './templates/edgeGroup.edit.view.html?t=' + window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(
            response => {
              showMessageToast(response.data.status.error)
              if (response.data.status.code === 0) {
                loadGroupDetails(groupId)
              }
            },
            function () {}
          )
      }
      $scope.confirmEdgeGroupDelete = (ev, groupId) => {
        // Appending dialog to document.body to cover sidenav in docs app
        var confirm = $mdDialog
          .confirm()
          .title($translate('areYouSureYouWantToDeleteThisEdgeGroup'))
          .textContent('')
          .ariaLabel($translate('deleteedgeGroup'))
          .targetEvent(ev)
          .ok($translate('delete'))
          .cancel($translate('cancel'))

        $mdDialog.show(confirm).then(
          function () {
            var request_json = {
              method: 'DELETE',
              url: EDGE_BASEURL + '/edge_groups/' + groupId,
              data: $scope.edgeData
            }
            $http(request_json).then(
              function (response) {
                edgeGroupFactory.deleteItemById(groupId)
                showMessageToast(response.data.status.error)

                // removing edges of edge group
                edgeFactory.list
                  .filter(e => e.groupId === groupId)
                  .forEach(e => {
                    edgeFactory.deleteItemById(e.id)
                  })
                // refresh ungrouped edges
                $scope.groupNavigation(-1, 'current')
              },
              function (response) {
                handleServerError(response)
                showMessageToast(response.data.status.error)
              }
            )
          },
          function () {
            // discard delete.
          }
        )
      }

      const loadGroupDetails = async groupId => {
        try {
          const requestJson = {
            method: 'GET',
            url: EDGE_BASEURL + '/edge_groups/' + groupId,
            data: {}
          }
          const response = await $http(requestJson)
          if (response.data.status.code === 0) {
            edgeGroupFactory.deleteItemById(-1)
            edgeGroupFactory.addOrUpdateItem(response.data.edgeGroup)
            edgeGroupFactory.list.push({
              id: -1,
              name: 'devices',
              opened: true
            })
          }
        } catch (error) {
          handleServerError(error)
        }
      }

      function handleServerError (response) {
        console.error(response)
        if (response && response.data) {
          if (response.data.statusCode == 401) {
            $scope.$emit('handleServerError', response)
          }
        } else {
          showMessageToast($translate('errorOccurred'))
        }
      }

      $scope.makeDefaultBroadCast = async userBroadcastView => {
        if (userBroadcastView.type == 1) {
          userBroadcastView.type = 0
        } else {
          userBroadcastView.type = 1
        }
        const requestJson = {
          method: 'PUT',
          url: BROADCAST_BASEURL + '/broadcastView/' + userBroadcastView.id,
          data: userBroadcastView
        }
        try {
          const response = await $http(requestJson)
          if (response.data.status.code === 0) {
            loadBroadcastViews()
          } else {
            showMessageToast(response.data.status.error)
          }
        } catch (error) {
          handleServerError(error)
        }
      }
      $scope.getCameraNameByStreamId = (edge, streamId) =>
        window.getCameraNameByStreamId($filter('translate'), edge, streamId)
      $scope.edegCollapse = async edge => {
        if ($mdMedia('xs') || $mdMedia('sm')) {
          $scope.$emit('sideStripToggle', {})
        }
        edge = edgeFactory.findItemById(edge.id).item
        edge.opened = !edge.opened
        edgeFactory.list.forEach(e => {
          if (edge.id !== e.id) {
            e.opened = false
            e.selected = false
            edgeFactory.addOrUpdateItem(e)
          }
        })
        edgeFactory.addOrUpdateItem(edge)
        if ($state.current.name === 'home.common.maps.view') {
          const edge_id = edge.id
          $scope.$emit('mapEvent', { edge_id })
        }
        if ($state.current.name === 'home.common.edge.list') {
          if (!edge.proxy_connected) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(
                  angular.element(document.querySelector('#popupContainer'))
                )
                .clickOutsideToClose(true)
                .title('')
                .textContent(
                  $translate('liveVideoIsNotAvailableAsTheCameraIsOffline')
                )
                .ok($translate('ok'))
                .targetEvent()
            )
          } else {
            if (edge.standby) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(
                    angular.element(document.querySelector('#popupContainer'))
                  )
                  .clickOutsideToClose(true)
                  .title('')
                  .textContent(
                    $translate('liveVideoIsNotAvailableWhileStandby')
                  )
                  .ok($translate('ok'))
                  .targetEvent()
              )
            } else {
              if (edge.opened) {
                edge.proxy_connected &&
                  $scope.$emit('deviceCamerasStatusRequest', {
                    serialNumber: edge.uri
                  })
              }
            }
          }
        } else if ($state.$current.includes['home.common.recordings']) {
          if (!edge.proxy_connected) {
            // offline
            edge.selected = false
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(
                  angular.element(document.querySelector('#popupContainer'))
                )
                .clickOutsideToClose(true)
                .title('')
                .textContent(
                  $translate('recordingsAreNotAvailableAsTheCameraIsOffline')
                )
                .ariaLabel(
                  $translate('recordingsAreNotAvailableAsTheCameraIsOffline')
                )
                .ok($translate('ok'))
                .targetEvent()
            )
            $scope.showEdgeRecordings(edge)
          } else {
            edge.selected = true
            $scope.showEdgeRecordings(edge)
          }
          edgeFactory.addOrUpdateItem(edge)
          // ~ console.log(edge)
        } else if ($state.current.name == 'home.common.events') {
          $scope.showEdgeEventHistory(edge)
        } else if ($state.current.name == 'home.common.reports') {
          $scope.showEdgeReportHistory(edge)
        }
      }
      $scope.showEdgeEventHistory = edge => {
        $state.go('home.common.events.history', { edge_id: edge.id })
      }
      $scope.showEdgeReportHistory = edge => {
        $state.go('home.common.reports.edge', { edge_id: edge.id })
      }
      $scope.showEdgeRecordings = edge => {
        edge.selected
          ? $state.go(
              browserInfo.name === 'Safari'
                ? 'home.common.recordings.list'
                : 'home.common.recordings.timeline',
              { edge_id: edge.id, deviceId: edge.id }
            )
          : $state.go('home.common.recordings')
      }
      $scope.edge_gps_locations = {}
      $scope.getFullDateTime = t => new Date(t).toString()
      $scope.showEdgeEventSettings = (
        edge,
        ev = null,
        isBulkDeviceSelection = false
      ) => {
        $mdDialog
          .show({
            locals: {
              dataFromCaller: {
                edge,
                isBulkDeviceSelection,
                ...(isBulkDeviceSelection && {
                  bulkDevicesSelections: getBulkDeviceSelections()
                })
              }
            },
            controller: 'EdgeEventSettingsController',
            templateUrl:
              './templates/edge.event.settings.view.html?t=' +
              window.webpackHash,
            // parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(() => {
            clearSelectionData()
            showMessageToast($translate('eventsStatusUpdatedSucessfully'))
          })
          .catch(() => {})
      }
      $scope.showBulkDeviceUiSettings = ev => {
        $mdDialog
          .show({
            controller: 'BulkDeviceUiSettingsEditController',
            templateUrl:
              './templates/bulk-device-ui-settings-edit.view.html?t=' +
              window.webpackHash,
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(data => {
            $scope.confirmUpdateUiSettings(ev, null, data, true)
          })
          .catch(() => {})
      }
      $scope.eventsvide_loading = false
      $scope.scrolllValue = true
      $scope.geofenceSettings = edge => {
        $scope.$emit('geofenceEvent', { edge_id: edge.id })
        $state.go('home.common.maps.geofence', { edge_id: edge.id })
      }
      $scope.stopPing = () => {
        $interval.cancel(statusTimer)
      }
      $scope.showGeofence = true
      $scope.showEdgeTrips = (ev, edge) => {
        $state.go('home.common.maps.edgeTrips', { edge_id: edge.id })
      }
    }
  ])
